import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigationArrow",
  "use": "navigationArrow-usage",
  "viewBox": "0 0 40 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 36\" id=\"navigationArrow\">\n\t<path fill=\"none\" stroke=\"currentColor\" strokeMiterlimit=\"20\" strokeWidth=\"1.5\" d=\"m15 15 4.934 6L25 15\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol